import { Step } from 'react-joyride'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { EditorTourStepIndex } from '../types'
import { getFloaterStepStyles, getOverlayStepStyle, TRANSLATION_KEY } from '../utils'
import { useTourConfig } from './useTourConfig'

export const useDownloadSteps = (): Step[] => {
  const { i18n } = useI18n()
  const { skipTourStep, onEndTour } = useTourConfig()
  const { isTablet, isPhone } = useMediaQueries()

  const onSkipStep = (stepIndex: EditorTourStepIndex) => {
    trackInternalEvent('skip_rb_onboarding_hint', {
      category: 'download',
      step: stepIndex + 1,
    })
    skipTourStep('download', stepIndex)
  }

  return [
    {
      offset: 0,
      disableBeacon: true,
      spotlightPadding: 0,
      spotlightClicks: true,
      styles: { options: { ...getOverlayStepStyle() } },
      showSkipButton: true,
      target: '#builder-download-button',
      placement: isTablet || isPhone ? 'top' : 'bottom',
      title: i18n.t(`${TRANSLATION_KEY}.download.step_1.title`),
      content: i18n.t(`${TRANSLATION_KEY}.download.step_1.content`),
      floaterProps: { styles: { ...getFloaterStepStyles() } },
      data: {
        onSkip: () => {
          onSkipStep(EditorTourStepIndex.DOWNLOAD_RESUME)
          onEndTour()
        },
        onClick: () => {
          trackInternalEvent('see_rb_onboarding_hint', {
            category: 'editor',
            step: EditorTourStepIndex.DOWNLOAD_RESUME + 1,
          })
          onEndTour()
        },
      },
    },
  ]
}
